/*
 * Copyright (c) 2015 - 2022 by KAA Soft. All rights reserved.
 */

// var i18n = window.i18n();
// var localeJSON = {
// 	"": {
// 		"language": "fr",
// 		"plural-forms": "nplurals=2; plural=n>1;"
// 	},
// 	"Welcome": "Bienvenue 123",
// 	"There is %1 apple": [
// 		"Il y a %1 pomme",
// 		"Il y a %1 pommes"
// 	]
// };
// i18n.loadJSON(localeJSON, 'messages');

window.i18n = window.i18n();
// console.info(i18n.gettext("foo"))